export const LINK_TO_SDK = 'https://documentcloud.adobe.com/view-sdk/main.js';
export const SCRIPT_TAG_SDK_ID = 'adobe-pdf-embed-sdk';
export const ADOBE_PDF_EMBED_DIV_ID = 'adobe-dc-view';
export const CLIENT_ID = '23e96689fd3240eaa9d6a9c5e454030e';
export const VIEW_OPTIONS = { FIT_WIDTH: 'FIT_WIDTH', FIT_PAGE: 'FIT_PAGE' };
